import { render } from "./CadastroFormasPagamentoView.vue?vue&type=template&id=274b97e9"
import script from "./CadastroFormasPagamentoView.vue?vue&type=script&lang=js"
export * from "./CadastroFormasPagamentoView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\SGCAD24\\Desenvolvimento\\Corofergs\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__